module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-attributes"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Vehicle Attributes")]), _c('div', {
    staticClass: "fa fa-plus",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.add = !_vm.add
      }
    },
    slot: "action"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add),
      expression: "add"
    }],
    staticClass: "attributes-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('selectize-vehicle-attribute', {
    staticClass: "input-group-field",
    on: {
      "optionSelected": _vm.updateAttributes
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "button fa fa-plus",
    on: {
      "click": _vm.addAttribute
    }
  })])], 1)])]), (_vm.addInProgress) ? _c('loading-spinner') : _vm._e()], 1), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.attributes), function(attribute, index) {
    return _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [(attribute.attribute.icon) ? _c('MdiIcon', {
      attrs: {
        "name": attribute.attribute.icon,
        "show-name": false
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(attribute.attribute.name))])], 1), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "input-group-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button default fa fa-save",
      on: {
        "click": function($event) {
          return _vm.saveAttribute(attribute)
        }
      }
    }), _c('button', {
      staticClass: "button warning fa fa-times",
      on: {
        "click": function($event) {
          return _vm.removeAttribute(index)
        }
      }
    })])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-799c02d7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleAttributes.vue
// module id = 2455
// module chunks = 1